// Reveal/RevealGroup's animate-decision logic, kept out of those files so
// each one exports only its component (react-refresh/only-export-components
// — see pageHeroLayout.ts for the same pattern). Also lets
// Reveal.test.tsx assert directly on this logic: the 2026-08-19 production
// incident was a hydration-mismatch bug (server bakes one state, client
// fails to correct it), which a single-pass render can't reproduce — testing
// the decision functions themselves is what actually guards against it.
//
// animate must never resolve to `undefined`: prerendering always runs
// without a real browser, so useReducedMotion() is always false at build
// time and the static markup always bakes in the hidden `{ opacity: 0, y }`
// state. `undefined` used to mean "don't command a target style" — on a
// client that actually prefers reduced motion, nothing ever told Motion to
// correct that baked-in hidden state during hydration, so content stayed
// invisible forever, with no error. Always giving an explicit target —
// instant for reduced motion, animated otherwise — guarantees hydration
// corrects it either way.
export function resolveRevealAnimate(
  shouldReduceMotion: boolean | null,
  hasRevealed: boolean,
  y: number,
) {
  return shouldReduceMotion || hasRevealed
    ? { opacity: 1, y: 0 }
    : { opacity: 0, y };
}

export function resolveRevealGroupAnimate(
  shouldReduceMotion: boolean | null,
  hasRevealed: boolean,
): "show" | "hidden" {
  return shouldReduceMotion || hasRevealed ? "show" : "hidden";
}
